<template>
  <div class="profile-page bg-light min-vh-100">
    <!-- Navbar -->
    <div class="bg-white shadow-sm sticky-top mb-4">
      <nav class="navbar navbar-expand-lg navbar-light container">
        <a class="navbar-brand font-weight-bold text-primary" href="#">
          <i class="fa fa-truck mr-2"></i>收貨資訊
        </a>
      </nav>
    </div>

    <div class="container pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="text-center mb-4">
            <h2 class="font-weight-bold text-dark">Step 3. 填寫寄送資料</h2>
            <p class="text-muted">
              請準確填寫您的收貨信息，以便我們盡快為您發貨
            </p>
          </div>

          <!-- Section 1: Recipient Information -->
          <div class="card border-0 shadow-sm mb-4">
            <div class="card-header bg-white border-bottom-0 pt-4 px-4 pb-0">
              <h5 class="font-weight-bold text-primary mb-0">
                <i class="fa fa-user-circle mr-2"></i>收件人資訊
              </h5>
            </div>
            <div class="card-body p-4">
              <div class="form-group mb-4">
                <label for="userName" class="font-weight-bold small text-muted"
                  >取件人姓名</label
                >
                <div class="input-group input-group-lg">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-light border-0"
                      ><i class="fa fa-user text-muted"></i
                    ></span>
                  </div>
                  <input
                    type="text"
                    class="form-control bg-light border-0"
                    id="userName"
                    placeholder="請填寫證件上的真實姓名"
                    v-model="from.name"
                  />
                </div>
                <small class="form-text text-muted mt-1">
                  * 貨到付款取貨需出示證件，請務必填寫真實姓名
                </small>
              </div>

              <div class="form-group mb-4">
                <label for="userPhone" class="font-weight-bold small text-muted"
                  >取件人手機</label
                >
                <div class="input-group input-group-lg">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-light border-0"
                      ><i class="fa fa-mobile text-muted"></i
                    ></span>
                  </div>
                  <input
                    type="number"
                    class="form-control bg-light border-0"
                    id="userPhone"
                    placeholder="例如：0912345678"
                    v-model="from.phone"
                  />
                </div>
                <small class="form-text text-muted mt-1">
                  * 商品抵達門市將發送簡訊通知，請填寫正確手機號碼
                </small>
              </div>

              <div class="form-group">
                <label for="userEmail" class="font-weight-bold small text-muted"
                  >電子郵件 <span class="text-danger">*</span></label
                >
                <div class="input-group input-group-lg">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-light border-0"
                      ><i class="fa fa-envelope text-muted"></i
                    ></span>
                  </div>
                  <input
                    type="text"
                    class="form-control bg-light border-0"
                    id="userEmail"
                    placeholder="接收訂單通知用"
                    v-model="from.email"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- Section 2: Logistics & Customs -->
          <div class="card border-0 shadow-sm mb-4">
            <div class="card-header bg-white border-bottom-0 pt-4 px-4 pb-0">
              <h5 class="font-weight-bold text-primary mb-0">
                <i class="fa fa-plane mr-2"></i>物流與報關
              </h5>
            </div>
            <div class="card-body p-4">
              <!-- International Transportation -->
              <div class="form-group mb-4">
                <label class="font-weight-bold text-dark mb-3"
                  >國際運輸方式</label
                >
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <div
                      class="custom-radio-card p-3 rounded"
                      :class="{
                        active: internationalTransportationSelected === '空運',
                      }"
                      @click="internationalTransportationSelected = '空運'"
                    >
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          id="transAir"
                          name="trans"
                          class="custom-control-input"
                          value="空運"
                          v-model="internationalTransportationSelected"
                        />
                        <label
                          class="custom-control-label font-weight-bold"
                          for="transAir"
                          >空運</label
                        >
                      </div>
                      <small class="d-block text-muted mt-2 ml-4 pl-1">
                        時效約 2 ~ 3 天<br />食品僅限空運
                      </small>
                    </div>
                  </div>
                  <div class="col-md-6 mb-2">
                    <div
                      class="custom-radio-card p-3 rounded"
                      :class="{
                        active: internationalTransportationSelected === '海快',
                      }"
                      @click="internationalTransportationSelected = '海快'"
                    >
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          id="transSea"
                          name="trans"
                          class="custom-control-input"
                          value="海快"
                          v-model="internationalTransportationSelected"
                        />
                        <label
                          class="custom-control-label font-weight-bold"
                          for="transSea"
                          >海快</label
                        >
                      </div>
                      <small class="d-block text-muted mt-2 ml-4 pl-1">
                        時效約 7 ~ 10 天<br />需超過 10 公斤
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Tax Options -->
              <div class="form-group mb-4">
                <label class="font-weight-bold text-dark mb-3">海關稅收</label>
                <div class="row">
                  <div class="col-12">
                    <div
                      class="custom-radio-card p-3 rounded"
                      :class="{ active: taxSelected === '包稅' }"
                      @click="taxSelected = '包稅'"
                    >
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          id="taxInclude"
                          name="tax"
                          class="custom-control-input"
                          value="包稅"
                          v-model="taxSelected"
                        />
                        <label
                          class="custom-control-label font-weight-bold"
                          for="taxInclude"
                          >多退少補</label
                        >
                      </div>
                      <div class="mt-2 ml-4 pl-1">
                        <div
                          class="alert alert-info border-0 bg-light-blue small mb-0"
                        >
                          <i class="fa fa-info-circle mr-1"></i>
                          預收稅款，採多退少補機制。
                          <a
                            href="https://chatxbuy.com/page/freight"
                            target="_blank"
                            class="text-info font-weight-bold"
                            ><u>點此查看說明</u></a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Customs Method -->
              <div class="form-group">
                <label class="font-weight-bold text-dark mb-3">報關方式</label>
                <div class="row">
                  <div class="col-md-6 mb-2">
                    <div
                      class="custom-radio-card p-3 rounded"
                      :class="{ active: taxMethodSelected === '個人報關' }"
                      @click="taxMethodSelected = '個人報關'"
                    >
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          id="customsPersonal"
                          name="customs"
                          class="custom-control-input"
                          value="個人報關"
                          v-model="taxMethodSelected"
                        />
                        <label
                          class="custom-control-label font-weight-bold"
                          for="customsPersonal"
                          >個人報關</label
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mb-2">
                    <div
                      class="custom-radio-card p-3 rounded"
                      :class="{ active: taxMethodSelected === '商業報關' }"
                      @click="taxMethodSelected = '商業報關'"
                    >
                      <div class="custom-control custom-radio">
                        <input
                          type="radio"
                          id="customsBusiness"
                          name="customs"
                          class="custom-control-input"
                          value="商業報關"
                          v-model="taxMethodSelected"
                        />
                        <label
                          class="custom-control-label font-weight-bold"
                          for="customsBusiness"
                          >商業報關</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Section 3: Delivery Method -->
          <div class="card border-0 shadow-sm mb-5">
            <div class="card-header bg-white border-bottom-0 pt-4 px-4 pb-0">
              <h5 class="font-weight-bold text-primary mb-0">
                <i class="fa fa-map-marker-alt mr-2"></i>取貨方式
              </h5>
            </div>
            <div class="card-body p-4">
              <div class="form-group mb-4">
                <label
                  for="shippingTypeSelected"
                  class="font-weight-bold text-dark"
                  >選擇取貨方式</label
                >
                <select
                  id="shippingTypeSelected"
                  class="custom-select custom-select-lg bg-light border-0"
                  v-model="shippingTypeSelected"
                >
                  <option
                    v-for="option in shippingTypeOptions"
                    :key="option.value"
                    :value="option.value"
                  >
                    {{ option.text }}
                  </option>
                </select>
              </div>

              <!-- Store Selection -->
              <div v-show="isStoreShow" class="fade-in">
                <div class="form-group">
                  <label
                    for="inputStore"
                    class="font-weight-bold text-muted small"
                    >選擇超商體系</label
                  >
                  <select
                    id="inputStore"
                    class="custom-select mb-3"
                    v-model="selectedStore"
                  >
                    <option
                      v-for="(storeOption, index) in storeOptions"
                      v-bind:key="(storeOption, index)"
                      v-bind:value="storeOption.value"
                    >
                      {{ storeOption.text }}
                    </option>
                  </select>

                  <button
                    class="btn btn-outline-success btn-lg btn-block dashed-border mb-3"
                    @click="selectStore()"
                  >
                    <i class="fa fa-plus-circle mr-2"></i>選擇 / 更改門市
                  </button>

                  <div
                    v-if="mapInfo"
                    class="selected-store-card p-3 rounded bg-light border border-success"
                  >
                    <h6 class="text-success font-weight-bold mb-2">
                      <i class="fa fa-check-circle mr-2"></i>已選擇門市
                    </h6>
                    <p class="mb-1">
                      <strong>門市名稱：</strong>{{ mapInfo.cvs_store_name }}
                    </p>
                    <p class="mb-1">
                      <strong>門市地址：</strong>{{ mapInfo.cvs_address }}
                    </p>
                    <p class="mb-0">
                      <strong>門市編號：</strong>{{ mapInfo.cvs_store_id }}
                    </p>
                  </div>

                  <div class="alert alert-warning mt-3 mb-0 small border-0">
                    <i class="fa fa-exclamation-triangle mr-1"></i>
                    注意：超商取貨重量上限 3kg，材積限制 45x30x30cm。需加收 40
                    元派送費。
                  </div>
                </div>
              </div>

              <!-- Home Delivery -->
              <div v-show="ishomeDeliveryShow" class="fade-in">
                <div class="form-group">
                  <label
                    for="userAddress"
                    class="font-weight-bold small text-muted"
                    >取件人地址</label
                  >
                  <input
                    type="text"
                    class="form-control form-control-lg bg-light border-0"
                    id="userAddress"
                    placeholder="請輸入詳細地址"
                    v-model="from.address"
                  />
                </div>

                <div class="alert alert-warning mt-3 mb-0 small border-0">
                  <i class="fa fa-exclamation-triangle mr-1"></i>
                  注意：宅配重量上限 70kg，長寬高限制 150x150x150cm。
                </div>
              </div>

              <div class="alert alert-danger mt-4 small border-0">
                <strong>外島地區運費說明：</strong><br />
                澎湖、馬祖、綠島、小琉球、蘭嶼、金門：<br />
                5kg以下 +100元，5kg以上 +120元，20kg以上 +330元。<br />
                若材積重量 > 實際重量*2，以 (材積+實重)/2 計算。
              </div>
            </div>
          </div>

          <!-- Submit Action -->
          <div class="mb-5 pb-5">
            <button
              class="btn btn-danger btn-lg btn-block shadow rounded-pill py-3 font-weight-bold"
              @click="submit()"
            >
              <i class="fa fa-paper-plane mr-2"></i>確認資料正確，送出委託單
            </button>
          </div>
        </div>
      </div>
    </div>

    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
    <v-dialog />
  </div>
</template>

<style scoped>
/* Custom Component Styles */
.custom-radio-card {
  border: 2px solid #e9ecef;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: white;
}

.custom-radio-card:hover {
  border-color: #dee2e6;
  background-color: #f8f9fa;
}

.custom-radio-card.active {
  border-color: #007bff;
  background-color: #f0f8ff;
}

.bg-light-blue {
  background-color: #e3f2fd;
  color: #0c5460;
}

.dashed-border {
  border-style: dashed;
  border-width: 2px;
}

.fade-in {
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Utilities override */
.input-group-text {
  min-width: 45px;
  justify-content: center;
}

.form-control:focus {
  background-color: #fff !important;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.15);
}

.card-header h5 i {
  opacity: 0.8;
}
</style>

<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'
import { isMobile } from 'mobile-device-detect'

export default {
  name: 'profile',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      webhookApiUrl: process.env.VUE_APP_WEBHOOK_API_URL,
      displayViews: null,
      isLoading: true,
      mapInfo: null,
      amounts: [],
      prodInfos: null,
      profileInfo: {},
      orderId: '',
      from: {
        name: '',
        phone: '',
        address: '',
        email: '',
      },
      isStoreShow: false,
      ishomeDeliveryShow: true,
      shippingTypeSelected: 'delivery',
      shippingTypeOptions: [
        {
          value: 'deliveryStore',
          text: '超商取貨',
        },
        {
          value: 'delivery',
          text: '宅配',
        },
      ],
      skuSelected: '',
      selectedStore: 'UNIMARTC2C',
      checkMobile: isMobile ? '1' : '0',
      storeOptions: [
        {
          text: '7-11 超商（7-11）',
          value: 'UNIMARTC2C',
        },
        {
          text: '全家 超商（全家）',
          value: 'FAMIC2C',
        },
      ],
      internationalTransportationSelected: '空運',
      taxSelected: '包稅',
      taxMethodSelected: '個人報關',
    }
  },
  methods: {
    submit: function () {
      const vm = this
      if (vm.from.name == '') {
        vm.$toast.open({
          message: '請輸入收件人姓名',
          type: 'error',
        })
        return 0
      }
      if (vm.from.phone == '') {
        vm.$toast.open({
          message: '請輸入收件人電話',
          type: 'error',
        })
        return 0
      }

      if (vm.from.email == '') {
        vm.$toast.open({
          message: '請輸入電子郵件',
          type: 'error',
        })
        return 0
      }

      if (vm.from.address.trim() == '' && vm.mapInfo == null) {
        vm.$toast.open({
          message: '請輸入收件資訊地址',
          type: 'error',
        })
        return 0
      }

      if (vm.from.address != '') {
        localStorage.setItem('address', vm.from.address)
        let formDataProfile = {
          userId: localStorage.userId,
          userAddress: vm.from.address,
        }

        axios
          .post(vm.apiUrl + 'UpdateProfileForAddress', formDataProfile, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function () {
            // console.log(response.data);
            // vm.isLoading = false;
          })
          .catch(function (error) {
            console.log(error)
            // vm.$toast.open({
            //   message: "失敗: " + error,
            //   type: "error"
            // });
            vm.isLoading = false
          })
      }

      if (vm.from.email != '') {
        localStorage.setItem('email', vm.from.email)
        let formDataProfile = {
          userId: localStorage.userId,
          email: vm.from.email,
        }

        axios
          .post(vm.apiUrl + 'UpdateProfileForEmail', formDataProfile, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function () {
            // console.log(response.data);
            // vm.isLoading = false;
          })
          .catch(function () {
            // console.log(error);
            // vm.$toast.open({
            //   message: "失敗: " + error,
            //   type: "error"
            // });
            vm.isLoading = false
          })
      }

      if (vm.prodInfos != undefined) {
        ;(async function postapi() {
          vm.isLoading = true

          vm.$toast.open({
            message: '建立委託單中，請稍等片刻...',
            type: 'success',
          })

          let formData = {
            prodInfos: vm.prodInfos,
            note: '',
            status: 0,
            logisticsInfo: {
              internationalTransportation:
                vm.internationalTransportationSelected,
              tax: vm.taxSelected,
              taxMethod: vm.taxMethodSelected,
            },
            productDelivery: vm.shippingTypeSelected,
            userId: localStorage.userId,
            userName: localStorage.userName,
            userImage: localStorage.userImage,
            userOrderName: vm.from.name,
            userPhone: vm.from.phone,
            mapInfo: vm.mapInfo,
            address: vm.from.address,
            userEmail: vm.from.email,
            priceInfo: 0,
            total: 0,
          }
          // console.log("AddOrder: " + JSON.stringify(formData));
          await axios
            .post(vm.apiUrl + 'AddOrder', formData, {
              headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
              },
            })
            .then(function (response) {
              if (Object.keys(response.data).length != 0) {
                vm.orderId = response.data.orderId
                vm.$toast.open({
                  message: '建立委託單完成!',
                  type: 'success',
                })

                vm.sendBidFbMessageConsumer(localStorage.userId, vm.orderId)
                vm.$router.replace('orderdone')
              }
              // console.log(response.data);
              vm.isLoading = false
            })
            .catch(function (error) {
              // console.log(error);
              vm.$toast.open({
                message: '失敗: ' + error,
                type: 'error',
              })
              vm.isLoading = false
            })
        })()
      } else {
        vm.$toast.open({
          message: '送出失敗',
          type: 'error',
        })
        vm.$modal.show('dialog', {
          title: '🙋請聯絡客服',
          text: '請聯絡客服⚡ 系統異常!',
          buttons: [
            {
              title: '👉聯絡客服',
              handler: () => {
                window.location = 'https://m.me/2266831083395361'
              },
            },
          ],
        })
      }
    },
    selectStore: function () {
      const vm = this
      if (vm.checkMobile == '1' && vm.selectedStore == 'UNIMARTC2C') {
        window.open(
          vm.apiUrl +
            'CepayMap?userId=' +
            localStorage.userId +
            '&logisticsSubType=' +
            vm.selectedStore +
            '&device=1'
        )
      } else if (vm.checkMobile == '0' && vm.selectedStore == 'UNIMARTC2C') {
        window.open(
          vm.apiUrl +
            'CepayMap?userId=' +
            localStorage.userId +
            '&logisticsSubType=' +
            vm.selectedStore +
            '&device=0'
        )
      } else {
        window.open(
          vm.apiUrl +
            'CepayMap?userId=' +
            localStorage.userId +
            '&logisticsSubType=' +
            vm.selectedStore +
            '&device=0'
        )
      }
    },
    sendBidFbMessageConsumer: function (userId, orderId) {
      const vm = this

      ;(async function post() {
        let formData = {
          userId: userId,
          tempType: 'apply_order',
          orderId: orderId,
        }
        await axios
          .post(vm.webhookApiUrl + 'SendMsgButtonTemplateV1.1', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function (response) {
            var data = response.data
            if (data.result == 'ok') {
              vm.$toast.open({
                message: '發送訊息!',
                type: 'success',
              })
            }
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '發送訊息失敗: ' + error,
              type: 'error',
            })
          })
      })()
    },
    checkUnChatbotSignin: function () {
      const vm = this

      try {
        if (
          vm.$route.query.userId &&
          vm.$route.query.userImage &&
          vm.$route.query.userName
        ) {
          localStorage.userId = decodeURI(vm.$route.query.userId)
          localStorage.userImage = decodeURI(vm.$route.query.userImage)
          localStorage.userName = decodeURI(vm.$route.query.userName)
          vm.userId = decodeURI(vm.$route.query.userId)
          vm.userImage = decodeURI(vm.$route.query.userImage)
          vm.userName = decodeURI(vm.$route.query.userName)
        }
      } catch (e) {
        // console.info(e);
        alert(e)
      }

      if (localStorage.userId == undefined) {
        vm.$modal.show('dialog', {
          title: '🙋您尚未登入FB會員',
          text: '請先登入才能使用此服務喔⚡',
          buttons: [
            {
              title: '👉用FB登入',
              handler: () => {
                window.location = 'https://m.me/2266831083395361'
              },
            },
          ],
        })
        // vm.$router.push("alibabaorder");
        return true
      } else {
        return false
      }
    },
    queryProfile: function () {
      const vm = this
      let formData = {
        userId: localStorage.userId,
        isValid: 1,
      }

      axios
        .post(vm.apiUrl + 'QueryProfile', formData, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
          },
        })
        .then(function (response) {
          if (Object.keys(response.data).length != 0) {
            if (response.data[0] != null) {
              vm.profileInfo = response.data[0]

              if (vm.profileInfo.email && vm.from.email == '') {
                vm.from.email = vm.profileInfo.email
              }
            }
          }
          vm.isLoading = false
        })
        .catch(function (error) {
          vm.$toast.open({
            message: '讀取會員失敗: ' + error,
            type: 'error',
          })
        })
    },
    queryMapInfo: function () {
      const vm = this
      let formData = {
        userId: localStorage.userId,
      }
      axios
        .post(vm.apiUrl + 'QueryMapInfo', formData, {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
          },
        })
        .then(function (response) {
          if (Object.keys(response.data).length != 0) {
            vm.mapInfo = response.data
            localStorage.setItem('mapInfo', vm.mapInfo)
          } else {
            vm.mapInfo = JSON.parse(localStorage.getItem('mapInfo'))
          }

          // console.log(response.data);
          vm.isLoading = false
        })
        .catch(function () {
          // console.log(error);
          // vm.$toast.open({
          //   message: "超商資訊讀取失敗: " + error,
          //   type: "error"
          // });
          vm.isLoading = false
        })
    },
  },
  watch: {
    'from.name': function () {
      const vm = this
      localStorage.setItem('name', vm.from.name)
    },
    'from.phone': function () {
      const vm = this
      localStorage.setItem('phone', vm.from.phone)
    },
    'from.address': function () {
      const vm = this
      localStorage.setItem('address', vm.from.address)
    },
    'from.email': function () {
      const vm = this
      localStorage.setItem('email', vm.from.email)
    },
    internationalTransportationSelected: function () {
      const vm = this
      if (vm.internationalTransportationSelected == '空運') {
        vm.taxSelected = '包稅'
      }
      // if (vm.internationalTransportationSelected == "海快") {
      //   vm.taxSelected = "不包稅";
      // }
    },
    taxSelected: function () {
      const vm = this
      if (
        vm.taxSelected == '不包稅' &&
        vm.internationalTransportationSelected == '空運'
      ) {
        alert('目前空運不支援不包稅')
      }
      // if (
      //   vm.taxSelected == "包稅" &&
      //   (vm.internationalTransportationSelected ==
      //     "海快 (未滿10公斤以10公斤計算)" ||
      //     vm.internationalTransportationSelected == "海快")
      // ) {
      //   alert("目前海快不支援包稅");
      // }
    },
    shippingTypeSelected: function () {
      const vm = this
      if (vm.shippingTypeSelected == 'deliveryStore') {
        vm.isStoreShow = true
        vm.ishomeDeliveryShow = false
      } else {
        vm.isStoreShow = false
        vm.ishomeDeliveryShow = true
      }
    },
  },
  computed: {},
  mounted() {
    const vm = this
    vm.isLoading = true
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    // Event snippet for 進入機器人收貨資料填寫頁面 conversion page
    vm.$ga.event('event', 'conversion', {
      send_to: 'AW-700538278/aWw0CJqP4rIBEKa7hc4C',
      value: 1.0,
      currency: 'TWD',
    })

    vm.checkUnChatbotSignin()
    vm.queryMapInfo()

    if (vm.$route.query.isStore == '1') {
      vm.shippingTypeSelected = 'deliveryStore'
      vm.isStoreShow = true
      vm.ishomeDeliveryShow = false
    }

    if (vm.$store.prodInfos != undefined) {
      vm.prodInfos = vm.$store.prodInfos
    } else if (JSON.parse(localStorage.getItem('prodInfos')) != undefined) {
      vm.prodInfos = JSON.parse(localStorage.getItem('prodInfos'))
    }

    if (vm.prodInfos == undefined) {
      vm.$modal.show('dialog', {
        title: '🙋請聯絡客服',
        text: '請聯絡客服⚡ 系統異常!',
        buttons: [
          {
            title: '👉聯絡客服',
            handler: () => {
              window.location = 'https://m.me/2266831083395361'
            },
          },
        ],
      })
    }

    if (localStorage.getItem('address') != undefined) {
      vm.from.address = localStorage.getItem('address')
    }
    if (localStorage.getItem('name') != undefined) {
      vm.from.name = localStorage.getItem('name')
    }
    if (localStorage.getItem('phone') != undefined) {
      vm.from.phone = localStorage.getItem('phone')
    }
    if (localStorage.getItem('email') != undefined) {
      vm.from.email = localStorage.getItem('email')
    }
    vm.queryProfile()
  },
}
</script>
